import vue from 'vue'

const state = {
    amount: undefined,
    year: undefined,
    week: undefined,
    stores: []
}

const mutations = {
    'UPDATE_VALUE' (state, payload) {
        vue.set(state, payload.variable, payload.value)
    }
}

const actions = {

}

const getters = {

}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
